import { mapGetters, mapMutations } from 'vuex';
//import { orderService } from '../../services/OrderService';
import EditPaymentComponent from './editPaymentComponent.vue';

import { userService } from '../../services/UserService';
import { attachmentService } from '../../services/AttachmentService';
//import { strictEqual } from 'assert';
import { Array, Number } from 'core-js';
import { EventBus } from '@/event-bus';

export default {
    name: 'OrderPayments',

    components: {
        EditPaymentComponent,
    },
    props: {

    },
    data: () => {
        return {
            loading: true,

            focusedRowObject: null,
            fields: [],
            itemToBeChanged: null,

            formatter: new Intl.NumberFormat('ro-RO', {
                style: 'currency',
                currency: 'RON',
            })
        }
    },
    computed: {
        ...mapGetters(
            {
                // general
                userProfile: 'user/profile',
                userHasRole: 'user/hasRole',
                orderTypeSettings: 'general/orderTypeSettings',
                appSettings: 'general/appSettings',
                settingsLoaded: 'general/settingsLoaded',

                //
                order: 'order/order',
            }),

        roles() {
            return userService.roles;
        },

        canHandleOrders() {
            return this.userHasRole(this.roles.admin) || this.userHasRole(this.roles.operator);
        },
    },

    created() {

        this.fields = [

            { key: 'Index', label: '#', sortable: false, thStyle: 'width:10px' },
            { key: 'DueAmount', label: 'Scadent', sortable: false, thStyle: 'width:40%' },
            { key: 'PaidDate', label: 'Incasat', sortable: false, thStyle: 'width:40%' },
            { key: 'Id', label: '', sortable: false },
        ];

        EventBus.$on('paymenFiles_uploaded', (orderId) => {
            this.$bvModal.hide('paymentModal');
        });
    },

    methods: {

        setItemToBeChanged(data) {

            if (data != null) {
                this.itemToBeChanged = data.item;
                this.$refs['paymentModal'].show();
            }
        },

        viewOrderButtonClick(data) {
            if (data != null) {
                var redirectPath = '/crm/order/edit/' + data.item.NextOrderId;
                this.$router.push({ path: redirectPath });
            }
        },

        getStatusVariant(item) {
            var badgeVariant = 'primary';
            if (item.Paid) {
                // policy was renewed
                badgeVariant = 'success'
            }
            else {
                var date = new Date();

                var today = new Date(date.getFullYear(), date.getMonth(), date.getDate());
                var endDate = new Date(item.DueDate);
                if (endDate > today) {
                    // not renewed and not expired
                    badgeVariant = 'warning';
                }
                else {
                    badgeVariant = 'danger';
                }
            }

            return badgeVariant;
        },

        getStatusText(item) {
            var badgeText = '';
            if (item.Paid) {
                // policy was renewed
                badgeText = 'Incasata'
            }
            else {
                badgeText = 'De incasat';
            }

            return badgeText;
        },

        //

        downloadPaymentReceipt: function (item) {
            var uploadParams = {
                targetType: 1,
                targetId: item.Id
            };
            attachmentService.getAllAttachments(uploadParams).then((response) => {
                var attachments = response.data;

                if (attachments && attachments.length > 0) {
                    if (attachments[0].url)
                        window.location.href = attachments[0].url;
                    else
                        window.location.href = 'api/Attachment/Download/' + attachments[0].Id;
                }
            })
        },

        updatePaymentButtonClick: function (bvModalEvt) {

            // Prevent modal from closing
            bvModalEvt.preventDefault();

            this.$refs.editPaymentComponent.savePayment();
            this.$refs.paymentsTable.refresh();
            // close modal
            //this.$nextTick(() => {
            //    this.$bvModal.hide('paymentModal');
            //})
        }

    }
}
